import React from 'react';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './unknownCreativeType.module.scss';

export const UnknownCreativeType = () => (
    <div className={styles['wrapper']}>
        <FormattedMessage id="creative.unknown.creative.type" defaultMessage="Unknown creative type" />
    </div>
);
